module.exports = __webpack_public_path__ + "img/dac-san-logo.196b1d34.jpg";